/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceState } from './resourceState';
import { ResourceCategory } from './resourceCategory';


export interface PatchResourceOperatorSpec { 
    category?: ResourceCategory;
    state?: ResourceState;
    force_patch?: boolean;
    metadata?: object;
    metadata_override?: boolean;
    /**
     * Any comment related to resource to be updated.
     */
    note?: string;
    params?: object;
    sharable?: boolean;
}
export namespace PatchResourceOperatorSpec {
}


